/**
 * Create Market screen
 */

import { useState } from "preact/hooks";
import { route } from "preact-router";
import { useStore } from "../store";
import { api } from "../api/client";

export function CreateMarket() {
  const { deviceId, setMarket, setUser, setSession } = useStore();
  const [name, setName] = useState("");
  const [adminName, setAdminName] = useState("");
  const [startingBalance, setStartingBalance] = useState(1000);
  const [inviteCode, setInviteCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await api.createMarket({
        name,
        adminName,
        startingBalance,
        deviceId,
        inviteCode: inviteCode || undefined,
      });

      setMarket(result.market);
      setUser(result.user);
      setSession(result.market.id, result.user.id);
      route(`/lobby/${result.market.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to create market");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div class="screen create-market">
      <header>
        <button class="btn-back" onClick={() => route("/")}>
          &larr; Back
        </button>
        <h2>Create Market</h2>
      </header>

      <form onSubmit={handleSubmit}>
        <div class="form-group">
          <label for="name">Market Name</label>
          <input
            id="name"
            type="text"
            value={name}
            onInput={(e) => setName(e.currentTarget.value)}
            placeholder="e.g., Thanksgiving 2024"
            required
          />
          <span class="form-hint">
            What's the occasion? This is what players will see.
          </span>
        </div>

        <div class="form-group">
          <label for="adminName">Your Display Name</label>
          <input
            id="adminName"
            type="text"
            value={adminName}
            onInput={(e) => setAdminName(e.currentTarget.value)}
            placeholder="e.g., Dad"
            required
          />
        </div>

        <div class="form-group">
          <label for="startingBalance">Starting Balance</label>
          <input
            id="startingBalance"
            type="number"
            value={startingBalance}
            onInput={(e) => setStartingBalance(Number(e.currentTarget.value))}
            min={100}
            max={10000}
          />
          <span class="form-hint">
            Virtual coins each player starts with for betting.
          </span>
        </div>

        <div class="form-group">
          <label for="inviteCode">Custom Invite Code (optional)</label>
          <input
            id="inviteCode"
            type="text"
            value={inviteCode}
            onInput={(e) => setInviteCode(e.currentTarget.value.toUpperCase())}
            placeholder="Leave blank for random"
            maxLength={6}
          />
          <span class="form-hint">
            Share this code with friends to let them join.
          </span>
        </div>

        {error && <div class="error">{error}</div>}

        <button type="submit" class="btn btn-primary" disabled={loading}>
          {loading ? "Creating..." : "Create Market"}
        </button>
      </form>
    </div>
  );
}
